import { AxiosResponse } from 'axios'
import IUpdateMotoristaRequest from 'modules/motorista/domain/entities/IUpdateMotoristaRequest'
import { ServiceConfig } from 'shared/services/ServiceConfig'

import ICreateMotoristas from '../../domain/entities/ICreateMotoristasRequest'
import IFindAllMotoristasRequest from '../../domain/entities/IFindAllMotoristasRequest'
import IFindAllMotoristasResponse from '../../domain/entities/IFindAllMotoristasResponse'
import IFindOneByIdAndFrotistaId from '../../domain/entities/IFindOneByIdAndFrotistaId'
import IMotorista from '../../domain/entities/IMotorista'
import { IMotoristaRepository } from '../../domain/repositories/IMotoristaRepository'

const http = new ServiceConfig()
export default class MotoristaRepository implements IMotoristaRepository {
  async create(motorista: ICreateMotoristas): Promise<IMotorista> {
    const result = await http.post<IMotorista, ICreateMotoristas>(
      '/motoristas/',
      motorista,
    )
    return result.data
  }

  async findByCpfNomeFrotistaId(
    params: IFindAllMotoristasRequest,
  ): Promise<IFindAllMotoristasResponse> {
    const { page, perPage, ativo, cpf, frotista_id, nome } = params

    const paramsFilter = {}

    if (params?.list_status) {
      params?.list_status.forEach((status, index) => {
        if (status !== '') {
          paramsFilter[`list_status[${index}]`] = status
        }
      })
    }

    const result: AxiosResponse<IFindAllMotoristasResponse> = await http.get(
      '/motoristas',
      {
        params: {
          page,
          per_page: perPage,
          ativo,
          cpf,
          nome,
          frotista_id,
          ...paramsFilter,
        },
      },
    )
    return result.data
  }

  findById(id: number): Promise<IMotorista> {
    throw new Error(id.toString())
  }

  findOneByIdAndFrotistaId(
    params: IFindOneByIdAndFrotistaId,
  ): Promise<IMotorista> {
    throw new Error(params.toString())
  }

  findOneByProtocolo(protocolo_ocr: string): Promise<IMotorista> {
    throw new Error(protocolo_ocr)
  }

  async update(
    motorista: IUpdateMotoristaRequest,
    id: number,
  ): Promise<IMotorista> {
    const result = await http.put<IMotorista, IUpdateMotoristaRequest>(
      `/motoristas/${id}`,
      motorista,
    )
    return result.data
  }

  async delete(id: number, frotistaId: number): Promise<void> {
    const query = `/motoristas/${id}`
    await http.delete(query, {
      frotista_id: frotistaId,
    })
  }

  public async getImagemMotorista(id: number): Promise<string> {
    const query = `/motoristas/imagem/${id}`
    const response: AxiosResponse<string> = await http.get(query)
    return response.data
  }
}
